import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Input } from 'antd';
import FormItem from '@/components/ui/FormItem';

interface ReportNameProps {
	onValueChange: (changed: boolean) => void;
}

export const ReportName: React.FC<ReportNameProps> = ({ onValueChange }) => {
	return (
		<Col xs={24} sm={12}>
			<FormItem
				name={['report_name']}
				label="Report name"
				labelCol={{ span: 24 }}
				requiredMessage="Enter a report name"
				required
			>
				<Input
					size="large"
					placeholder={I18n.get('Report name')}
					onChange={() => onValueChange(true)}
				/>
			</FormItem>
		</Col>
	);
};
